export default "__VITE_ASSET__BmteW09n__"